import * as fetch from 'isomorphic-fetch';
import * as Promise from 'es6-promise';
import { ActionType, ActionTypes } from '../../actions/index';
import { IAppState } from '../../reducers/index';
import { deleteSeatRequest } from '../../helpers/local-storage-helpers';

enum PromoFailure {
    PROMO_CONFLICT,
    PROMO_FAILURE
}
function _applyPromoCode(promoCode: string) {
    return {
        type: ActionTypes.APPLY_PROMO,
        value: promoCode
    }
}

export function loadPromoCode(promoCode) {
    return (dispatch, state) => {
        dispatch({ type: ActionTypes.LOAD_PROMO, value: promoCode });
    };
}


function errorPromoApply(message: string) {
    return {
        type: ActionTypes.PROMO_ERROR,
        value: message
    }
}

function errorPromoConflict(message: string) {
    return {
        type: ActionTypes.PROMO_CONFLICT,
        value: message
    }
}

export function cancelPromoApply() {
    return {
        type: ActionTypes.CANCEL_PROMO,
    }
}

function _removePromoCode() {
    return {
        type: ActionTypes.REMOVE_PROMO,
    }
}

function emptiedCart() {
    return {
        type: ActionTypes.EMPTIED_CART,
    }
}

export function emptyCart(promoCode: string) {
    return (dispatch, state) => {
        sendEmptyAndApplyRequest(promoCode).then((response: any) => {
            handlePromoApplicationResult(response, dispatch, state);
        });
    }
}

function sendEmptyAndApplyRequest(promoCode: string) {
    return fetch(`${window.location.origin}/api/seating/EmptyCartAndApply?promoCode=${promoCode}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

function sendApplyPromoRequest(promoCode: string) {
    var request = `${window.location.origin}/api/seating/ApplyPromoCode?promoCode=${promoCode}`;
    if (promoCode.length === 0) {
        request = `${window.location.origin}/api/seating/RemovePromoCode`;
    }
    return fetch(request,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin'
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                return "ERROR";
            }
        })
        .catch(error => {
            console.error(error);
        });
}

export function applyPromoCode(promoCode: string) {
    return (dispatch, state) => {
        dispatch(_applyPromoCode(promoCode));
        sendApplyPromoRequest(promoCode).then((response: any) => {
            handlePromoApplicationResult(response, dispatch, state);
        });
    }
}

export function removePromoCode() {
    return (dispatch, state) => {
        dispatch(_removePromoCode());
        sendApplyPromoRequest("").then((response: any) => {
            handlePromoApplicationResult(response, dispatch, state);
        });

        let updatedUrl = updateQueryStringParameter(window.location.href, 'promo', null);
        window.location.href = updatedUrl;
    }
}

function handlePromoApplicationResult(response, dispatch, state) {
    if (response.success) {
        const appSettings = (state() as IAppState).appSettingsModel;
        deleteSeatRequest(appSettings.itemId, appSettings.itemType);
        window.location.reload();
    }
    else if (!response.success && response.promoFailure === PromoFailure.PROMO_FAILURE) {
        dispatch(errorPromoApply(response.errorMessage));
    } else if (response.promoFailure === PromoFailure.PROMO_CONFLICT) {
        dispatch(errorPromoConflict(response.errorMessage));
    }

}

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        if (value === null) {
            return uri.replace(re, '$1');
        } else {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
    }
    else {
        return uri + separator + key + "=" + value;
    }
}